module.exports = __webpack_public_path__ + "media/images/azs_logo-c7cb758c11cb0e41a8bbdd32bb796a64.png";